export enum ButtonStyle {
    default = 'default',
    default_on_white_bg = 'default_on_white_bg',
    default_no_padding = 'default_no_padding',
    frameless = 'frameless',
    frameless_on_white_bg = 'frameless_on_white_bg',
    inverted = 'inverted',
    inverted_on_white_bg = 'inverted_on_white_bg',
    outlined = 'outlined',
    outlined_on_white_bg = 'outlined_on_white_bg',
    outlined_gray_on_white_bg = 'outlined_gray_on_white_bg',
    outlined_no_padding = 'outlined_no_padding',
    gray_and_white = 'gray_and_white',
    gray_and_white_no_padding = 'gray_and_white_no_padding',
    event_request_status_button = 'event_request_status_button',
    text_only = 'text_only',
    text_only_no_padding = 'text_only_no_padding',
    ghost = 'ghost',
    delete_action = 'delete_action',
    default_no_padding_on_white_bg = 'default_no_padding_on_white_bg',
    cyan_on_dark_bg = 'cyan_on_dark_bg'
}
